(() => {
  if (window.solfaireCatalogInit) return;
  window.solfaireCatalogInit = true;
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/ß/g, 'ss').trim();
  async function init(root = document) {
    for (const shell of root.querySelectorAll('.sf-catalog-shell')) {
      if (shell.dataset.initialized) continue;
      shell.dataset.initialized = 'true';
      const section = shell.closest('.sf-collection');
      const grid = shell.querySelector('[data-sf-grid]');
      const controls = section.querySelector('.sf-catalog-enhance');
      const strings = JSON.parse(section.querySelector('[data-sf-strings]').textContent);
      const status = shell.querySelector('.sf-catalog-status');
      const pager = shell.querySelector('.sf-client-pagination');
      const panel = controls.querySelector('.sf-filter-panel');
      const chips = controls.querySelector('[data-sf-applied]');
      const emptyReset = shell.querySelector('[data-sf-empty-reset]');
      const sortSelect = section.querySelector('[name=sort_by]');
      const form = section.querySelector('.sf-filters');
      let next = shell.querySelector('.sf-native-pagination [rel=next]');
      const visited = new Set();
      try {
        while (next) {
          const url = new URL(next.href, location.href);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalog page');
          visited.add(url.href);
          url.searchParams.set('section_id', shell.dataset.section);
          status.textContent = strings.loading;
          const response = await fetch(url, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Catalog unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const extra = doc.querySelector('.sf-catalog-shell');
          if (!extra) throw new Error('Missing catalog section');
          for (const card of extra.querySelectorAll('[data-sf-grid] > .sf-product')) grid.append(card);
          next = extra.querySelector('.sf-native-pagination [rel=next]');
        }
      } catch {
        status.textContent = strings.load_error;
        return;
      }
      const cards = [...grid.querySelectorAll(':scope > .sf-product')].map((card, index) => {
        const data = card.querySelector('.sf-card-specs')?.dataset || {};
        const values = key => (data[key] || '').split('|').map(s => s.trim()).filter(Boolean);
        return {card, index, size: values('sizes').map(value => value.replace(/^(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL)\s*\((Herren|Damen|Unisex)\)$/i,'$1')), color: values('colors'), brand: [data.brand || ''], grade: [data.grade || ''], type: [data.type || ''], price: Number(data.price), created: Number(data.created || 0), stock: data.available, text: normalize(card.textContent + ' ' + (data.brand || '') + ' ' + (data.colors || ''))};
      });
      const buckets = new Map();
      for (const item of cards) {
        const brand = item.brand[0];
        if (!buckets.has(brand)) buckets.set(brand, []);
        buckets.get(brand).push(item);
      }
      let rank = 0;
      while (rank < cards.length) for (const bucket of buckets.values()) if (bucket.length) bucket.shift().rank = rank++;
      const multiKeys = ['size', 'brand', 'color', 'grade', 'type'];
      const multi = new Map();
      const sizeOrder = ['XXXS','XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','4XL','5XL'];
      for (const key of multiKeys) {
        const select = controls.querySelector('[data-sf-filter="' + key + '"]');
        if (!select) continue;
        const values = [...new Set(cards.flatMap(item => item[key]).filter(Boolean))];
        values.sort((a,b) => {
          const x = sizeOrder.indexOf(a.toUpperCase()), y = sizeOrder.indexOf(b.toUpperCase());
          if (key === 'size' && (x >= 0 || y >= 0)) return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
          return a.localeCompare(b, document.documentElement.lang || 'de', {numeric:true});
        });
        if (!values.length) { select.closest('label').hidden = true; continue; }
        const label = select.closest('label');
        const title = label.firstChild.textContent.trim();
        const wrapper = document.createElement('div'); wrapper.className = 'sf-multi';
        const details = document.createElement('details');
        const summary = document.createElement('summary'); summary.textContent = title;
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend'); legend.textContent = title + ' · ' + strings.multiselect;
        fieldset.append(legend); details.append(summary, fieldset);
        select.multiple = true; select.hidden = true; select.removeAttribute('id'); select.replaceChildren();
        const entries = [];
        for (const value of values) {
          const option = new Option(value, value); select.add(option);
          const row = document.createElement('label');
          const checkbox = document.createElement('input'); checkbox.type = 'checkbox'; checkbox.value = value;
          const text = document.createElement('span'); text.textContent = value;
          row.append(checkbox, text); fieldset.append(row);
          entries.push({option, checkbox, text, value});
          checkbox.addEventListener('change', () => {option.selected = checkbox.checked; change();});
        }
        wrapper.append(details, select); label.replaceWith(wrapper);
        details.addEventListener('keydown', event => {if(event.key === 'Escape') {event.preventDefault(); details.open = false; summary.focus();}});
        multi.set(key, {select, entries, title, summary});
      }
      const inputs = [...controls.querySelectorAll('[data-sf-filter]')];
      const valueOf = input => input.multiple ? [...input.selectedOptions].map(option => option.value) : input.value;
      const setValue = (input, values) => {
        if (input.multiple) for (const option of input.options) option.selected = values.includes(option.value);
        else input.value = values[0] ?? '';
      };
      let page = 1;
      const pageSize = Number(shell.dataset.pageSize) || 16;
      const previous = pager.querySelector('[data-sf-prev]');
      const forward = pager.querySelector('[data-sf-next]');
      function readURL() {
        const params = new URLSearchParams(location.search);
        for (const input of inputs) {
          const values = params.getAll(input.name);
          setValue(input, values.length ? values : input.dataset.sfFilter === 'stock' ? ['true'] : []);
        }
        sortSelect.value = params.get('sort_by') || 'sf-discover';
        if (!sortSelect.value) sortSelect.value = 'sf-discover';
        const saved = Number(params.get('sf_page'));
        page = Number.isInteger(saved) && saved > 0 ? saved : 1;
      }
      function writeURL() {
        const url = new URL(location.href);
        for (const input of inputs) {
          url.searchParams.delete(input.name);
          const value = valueOf(input);
          if (Array.isArray(value)) for (const entry of value) url.searchParams.append(input.name, entry);
          else if (value || input.dataset.sfFilter === 'stock') url.searchParams.set(input.name, value);
        }
        if (sortSelect.value !== 'sf-discover') url.searchParams.set('sort_by',sortSelect.value);
        else url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        if (page > 1) url.searchParams.set('sf_page', String(page)); else url.searchParams.delete('sf_page');
        history.replaceState(null,'',url);
      }
      function render() {
        const state = Object.fromEntries(inputs.map(input => [input.dataset.sfFilter, valueOf(input)]));
        const invalid = state.min !== '' && state.max !== '' && Number(state.min) > Number(state.max);
        controls.querySelector('[data-sf-filter=max]').setCustomValidity(invalid ? strings.price_error : '');
        const terms = normalize(state.query || '').split(/\s+/).filter(Boolean);
        const matchesItem = (item, ignore = '') => terms.every(term => item.text.includes(term)) &&
          multiKeys.every(key => ignore === key || !state[key]?.length || state[key].some(value => item[key].includes(value))) &&
          (!state.stock || item.stock === state.stock) && (state.min === '' || item.price >= Number(state.min)*100) && (state.max === '' || item.price <= Number(state.max)*100);
        const matches = invalid ? [] : cards.filter(item => matchesItem(item));
        matches.sort((a,b) => {
          const stock = Number(b.stock === 'true') - Number(a.stock === 'true');
          if (stock) return stock;
          switch(sortSelect.value) {
            case 'price-ascending': return a.price-b.price || a.index-b.index;
            case 'price-descending': return b.price-a.price || a.index-b.index;
            case 'created-descending': return b.created-a.created || b.index-a.index;
            case 'created-ascending': return a.created-b.created || a.index-b.index;
            case 'title-ascending': return a.card.querySelector('.sf-product__meta span').textContent.localeCompare(b.card.querySelector('.sf-product__meta span').textContent);
            case 'title-descending': return b.card.querySelector('.sf-product__meta span').textContent.localeCompare(a.card.querySelector('.sf-product__meta span').textContent);
            case 'sf-discover': return a.rank-b.rank;
            default: return a.index-b.index;
          }
        });
        for (const [key, group] of multi) {
          const counts = new Map();
          for (const item of cards.filter(item => matchesItem(item, key))) for (const value of item[key]) counts.set(value, (counts.get(value) || 0)+1);
          for (const entry of group.entries) {
            const count = counts.get(entry.value) || 0;
            entry.checkbox.checked = entry.option.selected;
            entry.checkbox.disabled = count === 0 && !entry.option.selected;
            entry.text.textContent = entry.value + ' (' + count + ')';
          }
          const selected = group.entries.filter(entry => entry.option.selected);
          group.summary.textContent = group.title + (selected.length ? ' (' + selected.length + ')' : '');
        }
        const pages = Math.max(1, Math.ceil(matches.length / pageSize));
        page = Math.max(1, Math.min(page,pages));
        cards.forEach(item => {item.card.hidden = true;});
        const fragment = document.createDocumentFragment();
        for (const item of matches.slice((page-1)*pageSize,page*pageSize)) {item.card.hidden = false; fragment.append(item.card);}
        grid.append(fragment);
        section.querySelector('[data-sf-count]').textContent = matches.length + ' ' + strings.pieces;
        status.textContent = invalid ? strings.price_error : matches.length ? '' : strings.empty;
        emptyReset.hidden = matches.length > 0;
        pager.hidden = pages <= 1;
        pager.querySelector('[data-sf-page]').textContent = page + ' / ' + pages;
        previous.disabled = page <= 1; forward.disabled = page >= pages;
        chips.replaceChildren();
        let count = 0;
        for (const input of inputs) {
          const raw = valueOf(input); const values = Array.isArray(raw) ? raw : raw ? [raw] : [];
          for (const value of values) {
            count++;
            const key = input.dataset.sfFilter;
            const label = multi.get(key)?.title || input.closest('label')?.firstChild.textContent.trim() || '';
            const text = label + ': ' + (key === 'stock' ? input.selectedOptions[0].textContent : value);
            const button = document.createElement('button'); button.type = 'button'; button.textContent = text;
            const cross = document.createElement('span'); cross.textContent = '×'; cross.setAttribute('aria-hidden','true'); button.append(cross);
            button.setAttribute('aria-label', strings.remove + ' ' + text);
            button.addEventListener('click', () => {setValue(input,values.filter(entry => entry !== value)); change(); (chips.querySelector('button') || panel.querySelector('summary')).focus();});
            chips.append(button);
          }
        }
        controls.querySelector('[data-sf-filter-count]').textContent = count ? '('+count+')' : '';
        if (inputs.some(input => input.dataset.sfFilter !== 'stock' && valueOf(input).length)) {
          const clear = document.createElement('button'); clear.type = 'button'; clear.textContent = strings.reset; clear.addEventListener('click',reset); chips.append(clear);
        }
      }
      function change() {page = 1; render(); writeURL();}
      function reset() {inputs.forEach(input => setValue(input,input.dataset.sfFilter === 'stock' ? ['true'] : [])); change();}
      inputs.filter(input => !input.multiple).forEach(input => input.addEventListener('change',change));
      let debounce;
      for (const input of inputs.filter(input => input.tagName === 'INPUT')) input.addEventListener('input', () => {clearTimeout(debounce); debounce = setTimeout(change,160);});
      controls.querySelector('[data-sf-reset]').addEventListener('click',reset);
      emptyReset.addEventListener('click',reset);
      controls.querySelector('[data-sf-show-results]').addEventListener('click', () => {if(!form.reportValidity()) return; panel.open=false; grid.scrollIntoView({block:'start',behavior:'auto'});});
      for (const [button,delta] of [[previous,-1],[forward,1]]) button.addEventListener('click', () => {page += delta; render(); writeURL(); grid.scrollIntoView({block:'start',behavior:'auto'});});
      shell.querySelectorAll('.sf-native-pagination').forEach(nav => {nav.hidden=true;});
      form.addEventListener('submit',event => {event.preventDefault(); if(form.reportValidity()) change();});
      sortSelect.addEventListener('change',change);
      window.addEventListener('popstate',() => {readURL();render();});
      controls.hidden=false; panel.open=false; readURL();render();
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init()); else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
